import _extends from "@babel/runtime/helpers/extends";
import { Box, Button } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './siteLevelGateHomeOptimized.scss';
export const HeroSearchBar = _ref => {
  let {
    onSubmit
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    autoFocus: false,
    showSearchIcon: true,
    hideFilters: true,
    hideClearButton: true,
    placeholder: t('domains_search_gate.gate_revamp.searchbar.placeholder'),
    onSubmit: onSubmit,
    Layouts: {
      SearchContainer: _ref2 => {
        let {
          children,
          className,
          ...props
        } = _ref2;
        return /*#__PURE__*/React.createElement(Box, _extends({
          direction: "vertical",
          backgroundColor: "#FFFFFF",
          width: "100%",
          zIndex: 1
        }, props, {
          className: [s.searchContainer, className].filter(Boolean).join(' ')
        }), children);
      },
      InputContainer: _ref3 => {
        let {
          children,
          ...props
        } = _ref3;
        return /*#__PURE__*/React.createElement(Box, _extends({
          direction: "horizontal",
          verticalAlign: "middle",
          align: "space-between",
          width: "100%",
          padding: "8px",
          flex: 1,
          gap: "4px"
        }, props), children);
      },
      ActionButton: _ref4 => {
        let {
          children: _icon,
          size: _size,
          priority: _priority,
          ...props
        } = _ref4;
        return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
          size: "large",
          skin: "dark"
        }), t('domains_search_gate.gate_revamp.searchbar.submit.cta'));
      },
      ToolBarContainer: () => /*#__PURE__*/React.createElement(React.Fragment, null)
    }
  });
};
//# sourceMappingURL=HeroSearchBar.js.map